export default function falsy(value) {
  return !value
}
